export default __webpack_public_path__ + "static/char-s-05-chs-8f4284fc31961ac885c554999b885f81.png";